import { render, staticRenderFns } from "./SentimentZhaban.vue?vue&type=template&id=445ae883&scoped=true"
import script from "./SentimentZhaban.vue?vue&type=script&lang=js"
export * from "./SentimentZhaban.vue?vue&type=script&lang=js"
import style0 from "./SentimentZhaban.vue?vue&type=style&index=0&id=445ae883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ae883",
  null
  
)

export default component.exports